export const DRAWING_TYPE = {
  PEN: 'PEN',
  POLYGON: 'POLYGON',
  ERASER: 'ERASER',
} as const;

export const DEFAULT_TYPE = DRAWING_TYPE.PEN;

export const DEFAULT_SIZE = 20;
